module.exports = __webpack_public_path__ + "static/panneau-173fedb1726ceff64e8e4b181a7e0919.jpg";